export function $(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element #${id}`);
  return el;
}

export type StatusType = 'loading' | 'error' | 'success';

export function showStatus(message: string, type: StatusType) {
  const status = $('status');
  const statusText = $('statusText');
  statusText.textContent = message;
  status.className = 'status ' + type;
  (status as HTMLElement).style.display = 'block';

  if (type !== 'loading') {
    ($('progress') as HTMLElement).style.display = 'none';
  }
}

export function updateProgress(percent: number, text: string) {
  (document.getElementById('progressFill') as HTMLElement).style.width = percent + '%';
  $('progressText').textContent = text;
  ($('progress') as HTMLElement).style.display = 'block';
}

export function setMeta(items: Array<{ k: string; v: string }>) {
  const meta = $('meta') as HTMLElement;
  const metaGrid = $('metaGrid');
  metaGrid.innerHTML = '';
  if (!items.length) {
    meta.style.display = 'none';
    return;
  }
  meta.style.display = 'block';
  for (const { k, v } of items) {
    const row = document.createElement('div');
    row.className = 'kv';
    const keyEl = document.createElement('b');
    keyEl.textContent = k;
    const valEl = document.createElement('div');
    valEl.style.wordBreak = 'break-all';
    valEl.textContent = v;
    row.appendChild(keyEl);
    row.appendChild(valEl);
    metaGrid.appendChild(row);
  }
}

